import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { Button } from 'primeng/button';
import { Card } from 'primeng/card';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ApplicationFormHistory } from '../../../../../shared/models/application-form-history';
import { HistoryEventDetailsComponent } from '../../../../../shared/components/history-event-details/history-event-details.component';
import { ApplicationUtils } from '../../../../../shared/utils/application.utils';

@Component({
  selector: 'app-application-history-entry-details-dialog',
  imports: [Button, Card, DatePipe, HistoryEventDetailsComponent],
  templateUrl: './application-history-entry-details-dialog.html',
  styleUrl: './application-history-entry-details-dialog.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApplicationHistoryEntryDetailsDialog {
  event = input.required<ApplicationFormHistory>();
  protected readonly dialogRef = inject(DynamicDialogRef);

  protected close(): void {
    this.dialogRef.close();
  }

  protected readonly ApplicationUtils = ApplicationUtils;
}
